var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConnectEnvelopeWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 0C0.839844 0 0 0.827815 0 1.84814C0 2.42954 0.277344 2.97628 0.75 3.32666L9.25 9.61035C9.69531 9.93763 10.3047 9.93763 10.75 9.61035L19.25 3.32666C19.7227 2.97628 20 2.42954 20 1.84814C20 0.827815 19.1602 0 18.125 0H1.875ZM0 4.31234V12.321C0 13.6801 1.12109 14.7852 2.5 14.7852H17.5C18.8789 14.7852 20 13.6801 20 12.321V4.31234L11.5 10.596C10.6094 11.2544 9.39062 11.2544 8.5 10.596L0 4.31234Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectEnvelopeWhite);
export default __webpack_public_path__ + "static/media/connect_envelope_white.8308994dd2066b9f6d5bd9c42020de58.svg";
export { ForwardRef as ReactComponent };